// Angular Import
import { Component, OnInit, inject, HostListener } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NavService } from '../app/theme/shared/service/navservice';
import { MenuRightsService } from '../app/theme/shared/service/menu_rights.service';

// project import 
import { SpinnerComponent } from './theme/shared/components/spinner/spinner.component';
import { GlobalSearchComponent } from './project_files/shared/menu_search/menu_search.component';

import { LoadingService } from './theme/shared/service/loading.service';
import { LoadingBarComponent } from './theme/shared/service/loading';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingBarComponent,AsyncPipe],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private router = inject(Router);

  loading$ = this.loadingService.loading$;

  constructor(private NavService: NavService, private dialog: MatDialog, private MenuRightsService: MenuRightsService,
    private loadingService: LoadingService,) { }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {

    if (event.ctrlKey && event.key.toLowerCase() === 'g') {

      event.preventDefault();

      this.dialog.open(GlobalSearchComponent, {
        width: '500px',
        height: '500px'
      });
    }
  }


  // life cycle event
  ngOnInit() {

    this.NavService.UpdateMenuList();
    this.MenuRightsService.getMeuDetails();

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
